import { render, staticRenderFns } from "./editProblem.vue?vue&type=template&id=1d38f262&scoped=true&"
import script from "./editProblem.vue?vue&type=script&lang=js&"
export * from "./editProblem.vue?vue&type=script&lang=js&"
import style0 from "./editProblem.vue?vue&type=style&index=0&id=1d38f262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38f262",
  null
  
)

export default component.exports